export default "__VITE_ASSET__c5a2d8f5__"